import { useMemo } from 'react';
import { useDefaultAccountsActions } from '#/preferences/default-accounts/context';
import { useAccounts } from '#/unified-rfqs/contexts/accounts';
import { AccountResponse } from '@paradigm/api/src/accounts';
import { Maybe } from '@paradigm/utils/types';
import { Source } from '#/unified-rfqs/entities/products/venue';

export default function useAccountsWithDefault(
  venue: string,
  productCode: Maybe<string>,
): AccountResponse[] {
  const accounts = useAccounts();
  const { getDefaultAccount } = useDefaultAccountsActions();
  const defaultAccount = getDefaultAccount(venue as Source, productCode);

  return useMemo(() => {
    const venueAccounts = [...accounts.selectByVenue(venue as Source)];

    return venueAccounts.map((acc) => ({
      ...acc,
      is_default: acc.name === defaultAccount,
    }));
  }, [accounts, defaultAccount, venue]);
}
